import React from 'react';

const OrderFilterTabs = ({ tabs, filterStatus, onChange, onRefresh }) => (
  <div className="flex items-center gap-2 flex-wrap">
    {tabs.map(([val, label]) => (
      <button
        key={val}
        onClick={() => onChange(val)}
        className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
          filterStatus === val ? 'bg-blue-600 text-white' : 'bg-white border border-gray-300 text-gray-600 hover:bg-gray-50'
        }`}
      >
        {label}
      </button>
    ))}
    <button onClick={onRefresh} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50">
      刷新
    </button>
  </div>
);

export default OrderFilterTabs;